import tw, { styled } from 'twin.macro'
import { Text4xlLeading10FontSemiboldBlueGray900 } from '@flowwai-frontend/shared/style-guide'
export const YourTeamsLoadingWrapper = styled.div`
   display: flex;
   margin-top: 32px;
   width: 100%;
   gap: 32px;
   overflow-x: auto;
   margin-bottom: 0.25rem;
   max-width: calc(100vw - 100px);
`
export const TeamLoadingWrapper = styled.div`
   height: 192px;
   min-width: 304px;
   cursor: pointer;
   display: flex;
   flex-direction: column;
   border-radius: 16px;
   --bg-opacity: 1;
   padding: 24px;
   margin-bottom: 1.5rem;
   border: 1px solid rgba(228, 231, 235);
   max-width: 304px;
`

export const TeamsPrefixAndDisplayNameLoadingWrapper = styled.div`
   display: flex;
   align-items: center;
`

export const ContentLoadingWrapper = styled.div`
   display: flex;
   flex-direction: column;
   margin-top: 20px;
`

export const TeamsListLoadingWrapper = styled.div`
   padding: 24px 24px 0px;
   --bg-opacity: 1;
   background-color: rgba(255, 255, 255, var(--bg-opacity));
   margin: 94px 32px 0px;
   border-radius: 12px;
`
export const YourTeamsBodyLoadingWrapper = styled.div`
   display: flex;
   align-items: flex-start;
   overflow: auto;
   background-color: rgba(245, 247, 250, var(--bg-opacity));
   --bg-opacity: 1;
   padding-left: 20px;
   height: 100%;
`

export const TeamsRouteHeader = styled.div`
   ${tw`flex flex-row justify-between`}
`
export const TeamsTitleLoader = styled(Text4xlLeading10FontSemiboldBlueGray900)`
   ${tw`leading-0.83`};
   font-size: 30px;
`

export const YourTeamsRouteLoadingWrapper = styled.div`
   ${tw`h-full overflow-hidden`}
`
